import { createKeyFactory } from '@clouway/query'

export const trackingObjectsKeys = createKeyFactory('tracking-objects')

export const trackingObjectsListKey = (customerId: string) => trackingObjectsKeys.custom('list', customerId)

export const trackingObjectStatusKey = (customerId: string, tid: string) =>
  trackingObjectsKeys.custom('status', customerId, tid)

export const trackingObjectConfigKey = (customerId: string, tid: string) =>
  trackingObjectsKeys.custom('config', customerId, tid)

export const trackingObjectDetailKey = (customerId: string, tid: string) =>
  trackingObjectsKeys.custom('detail', customerId, tid)
